import React from 'react';
import Button from '../Button/Button';
import './ContactForm.scss';

const ContactForm = () => {
  return (
    <section
      className='contact'
      id='contact'>
      <div className='container'>
        <div className='contact__wrapper'>
          {/* Linke Seite */}
          <div className='contact__info'>
            <h2>
              Kontaktieren Sie uns <br />
              und erhalten Sie ein individuelles <br />
              Reinigungsangebot
            </h2>

            <p className='contact__desc'>
              Ihre Anfrage wird schnellstmöglich bearbeitet, <br />
              und unser Team meldet sich umgehend bei Ihnen, <br />
              um alle Details zu besprechen.
            </p>

            <div className='contact__details'>
              <a
                href='tel:+4917670729363'
                className='contact__phone'>
                +49 176 70729363
              </a>
              <span className='contact__label'>Kundenhotline</span>

              {/* Добавляем e-mail */}
              <a
                href='mailto:melik.reinigung@gmail.com'
                className='contact__email'>
                melik.reinigung@gmail.com
              </a>
              <span className='contact__label'>E-Mail Support</span>

              <p className='contact__address'>Krayer str 45, 45276 Essen</p>
              <span className='contact__label'>
                Öffnungszeiten:
                <br />
                Montag–Freitag: 09:00–18:00 Uhr
                <br />
                Samstag: 09:00–14:00 Uhr
              </span>
            </div>
          </div>

          {/* Rechte Seite — Formular */}
          <form
            className='contact__form'
            action='https://public.herotofu.com/v1/fd6466e0-b03b-11f0-87c8-1b4ee8716038'
            method='POST'
            acceptCharset='UTF-8'>
            <input
              type='text'
              name='Name'
              placeholder='Ihr Name'
              required
            />
            <input
              type='tel'
              name='Telefon'
              placeholder='Ihre Telefonnummer'
              required
              inputMode='tel'
              maxLength='20'
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9+\-\s()]/g, '');
              }}
              title='Bitte geben Sie eine gültige Telefonnummer ein (z. B. +49 176 1234567)'
            />

            {/* Новое поле для email */}
            <input
              type='email'
              name='E-Mail'
              placeholder='Ihre E-Mail-Adresse'
              required
              onInput={(e) => {
                e.target.setCustomValidity('');
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value)) {
                  e.target.setCustomValidity(
                    'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
                  );
                }
              }}
            />

            <textarea
              name='Nachricht'
              placeholder='Ihre Nachricht oder Anfrage'
              rows='4'></textarea>

            <input
              type='text'
              name='_gotcha'
              style={{ display: 'none' }}
            />

            <Button
              text='Anfrage senden'
              type='submit'
            />
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
